(() => {
  const launch = document.querySelector('[data-neulo-launch-at]');
  if (!launch) return;
  const startsAt = Date.parse(launch.dataset.neuloLaunchAt);
  if (!Number.isFinite(startsAt)) return;
  const forced = launch.dataset.neuloPreviewOpen === 'true';
  let previous;
  function update() {
    const open = forced || Date.now() >= startsAt;
    if (open === previous) return;
    previous = open;
    document.querySelectorAll('[data-neulo-phase]').forEach(node => {
      node.hidden = node.dataset.neuloPhase !== (open ? 'after' : 'before');
    });
    document.querySelectorAll('[data-neulo-phase-cta]').forEach(link => {
      link.href = open ? link.dataset.neuloAfterUrl : link.dataset.neuloBeforeUrl;
      const label = link.querySelector('[data-neulo-cta-label]') || link.querySelector('span') || link;
      label.textContent = open ? link.dataset.neuloAfterLabel : link.dataset.neuloBeforeLabel;
    });
  }
  update();
  const timer = setInterval(() => { update(); if (previous) clearInterval(timer); }, 1000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
})();
